import MainHeading from '@/components/common/MainHeading'
import Layout from '@/components/layout/Layout'
import React from 'react'

const Transfer: React.FC = () => {
    return (
        <Layout>
            <div className='space-y-6'>
                <MainHeading title='Transfer Management' />
            </div>
        </Layout>
    )
}

export default Transfer